import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function FeaturedSection() {
  const featured = movies.filter((m) => m.featured);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-14 md:mt-20">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">编辑团队精心挑选的高分佳作</p>
        </div>
        <Link
          to="/category/dianying"
          className="text-sm text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.map((movie) => (
          <Link
            key={movie.id}
            to={`/article/${movie.id}`}
            className="group bg-background-100 border border-background-200/40 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[2/3] overflow-hidden">
              <img
                src={movie.poster}
                alt={`${movie.title} - 91片库高清在线观看`}
                title={`${movie.title} ${movie.year} ${movie.quality} - 91片库`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2 px-2 py-1 bg-primary-500 text-background-950 text-xs font-semibold rounded-md">
                {movie.quality}
              </div>
              <div className="absolute top-2 right-2 px-2 py-1 bg-background-950/70 backdrop-blur-sm text-foreground-200 text-xs rounded-md">
                {movie.rating}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-sm text-foreground-100">{movie.description.slice(0, 50)}...</span>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
                <span>{movie.year}</span>
                <span className="text-foreground-700">·</span>
                <span>{movie.region}</span>
                <span className="text-foreground-700">·</span>
                <span>{movie.duration}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}